import { render } from "./FolderTreeRow.vue?vue&type=template&id=0628e168&scoped=true"
import script from "./FolderTreeRow.vue?vue&type=script&lang=js"
export * from "./FolderTreeRow.vue?vue&type=script&lang=js"

import "./FolderTreeRow.vue?vue&type=style&index=0&id=0628e168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0628e168"]])

export default __exports__